import { render, staticRenderFns } from "./Informs.vue?vue&type=template&id=54d4a91e&scoped=true&"
import script from "./Informs.vue?vue&type=script&lang=js&"
export * from "./Informs.vue?vue&type=script&lang=js&"
import style0 from "./Informs.vue?vue&type=style&index=0&id=54d4a91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d4a91e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VDatePicker,VDialog,VSpacer,VTextField})
